import React from "react";
import TradeInAemModelMonthlyPrice from "./TradeInAemModelMonthlyPrice";
import TradeInAemModelCashPrice from "./TradeInAemModelCashPrice";
import type { ModelResultType } from "../../../../../shared-logic/features/filters/utils/constants/resultConstants";
import * as Styles from "./style/TradeInAemModelPriceStyles";

type ModelResultPriceType = {
    model: ModelResultType;
};

// Price formatting and rendering is based on the AEM model-filter component.
const TradeInAemModelPrice = (props: ModelResultPriceType): JSX.Element | null => {
    const { model } = props;
    const { cars, cheapestCar = cars[0], cheapestCarMonthly = cars[0] } = model;

    // Cash and monthly are separate components for easier readability and maintenance.
    return (
        <Styles.PriceWrapper>
            <TradeInAemModelCashPrice price={cheapestCar?.price} modelCode={cheapestCar.model.code} />
            {!!cheapestCarMonthly?.price.monthly && (
                <TradeInAemModelMonthlyPrice
                    financeInfo={cheapestCarMonthly.finance}
                    price={cheapestCarMonthly.price}
                    modelCode={cheapestCarMonthly.model.code}
                />
            )}
        </Styles.PriceWrapper>
    );
};

export default TradeInAemModelPrice;
